var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"toastProp",style:({'--top': _vm.top, '--left': _vm.left, '--width': _vm.width, '--bottom':_vm.bottom})},[_c('img',{staticClass:"close",attrs:{"src":require("images/关闭@2x.png"),"alt":""},on:{"click":_vm.close}}),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }